<script>
import Layout from "../../layouts/main";

export default {
  components: { Layout },
  data() {
    return {
      userinfo: {},
      processing: true,
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    this.submitCallback();
  },
  methods: {
    post(action, payload) {
      return this.$axios.post(
        this.apiuri,
        Object.assign({ action: action }, payload || {}),
        { headers: { Openid: this.userinfo.openid } }
      );
    },
    submitCallback() {
      var that = this;
      var query = Object.assign({}, that.$route.query);
      if (!query.access_token) {
        that.finish(false);
        return;
      }
      that.post("syncbindportalcallback", { callback: query })
        .then(function (response) {
          that.finish(response.data.status === 200);
        })
        .catch(function () {
          that.finish(false);
        });
    },
    finish(ok) {
      this.processing = false;
      this.$router.replace({
        path: "/clouds/cloud-bind",
        query: { bind: ok ? "success" : "fail" },
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center py-5" v-loading="processing">
      <div class="col-lg-6 text-center text-muted">
        {{ $t("menuitems.clouds.cloudbind.callback_processing") }}
      </div>
    </div>
  </Layout>
</template>
